import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import BudgetStocksInFocusLive from '../../collection-templates/budget-stocks-in-focus-live';
import isEmpty from 'lodash/isEmpty';

export const StocksInFocusLiveFullWidget = (props) => {
  const [collectionData, setCollectionData] = useState({});
  const [darkMode, setDarkMode] = useState(false);
  const [lightMode, setLightMode] = useState(false);
  const [showValues, setShowValues] = useState(false);
  const queryClient = new QueryClient();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const dm = urlParams.get('dm');
    const disabledm = urlParams.get('disabledm');
    const showValues = urlParams.get('showValues');

    if (showValues === '1') {
      setShowValues(true);
    }

    if (dm == 1) {
      setDarkMode(true);
      setLightMode(false);
    } else if (disabledm == 1) {
      setDarkMode(false);
      setLightMode(true);
    } else {
      setDarkMode(false);
      setLightMode(false);
    }

    if (disabledm === '1') {
      const body = document.getElementsByTagName('body')[0];
      body.style.backgroundColor = '#FFFFFF';
    } else if (
      dm === '1' ||
      (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches)
    ) {
      const body = document.getElementsByTagName('body')[0];
      body.style.backgroundColor = '#2B2B2B';
    }

    const getCollectionData = async () => {
      if (isEmpty(collectionData)) {
        try {
          const response = await fetch(
            'https://www.ndtvprofit.com/api/v1/collections/stocks-radar?limit=15',
          ).then((res) => res.json());
          setCollectionData(response);
        } catch (e) {
          console.log('Error in api');
        }
      }
    };

    getCollectionData();
  }, []);

  useEffect(() => {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    body.style.overscrollBehaviorY = 'auto';

    const style = document.createElement('style');
    style.innerHTML = `
        body::-webkit-scrollbar {
          background-color: transparent;
        }
      `;
    document.head.appendChild(style);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      {!isEmpty(collectionData) && (
        <BudgetStocksInFocusLive
          collection={collectionData}
          widget={true}
          darkMode={darkMode}
          lightMode={lightMode}
          showValues={showValues}
          {...props}
        />
      )}
    </QueryClientProvider>
  );
};
